export default function(){
    return encodeURIComponent(document.location.href.replace(/#.*$/, ""));
};